import React, { useEffect } from "react";
import "@/App.css";
import axios from "axios";
import { Toaster } from "sonner";

import Nav from "@/sections/Nav";
import Hero from "@/sections/Hero";
import Services from "@/sections/Services";
import Work from "@/sections/Work";
import Results from "@/sections/Results";
import Partners from "@/sections/Partners";
import Testimonials from "@/sections/Testimonials";
import Footer from "@/sections/Footer";
import { useLenis } from "@/hooks/useLenis";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function App() {
  useLenis();

  useEffect(() => {
    axios.get(`${API}/`).catch(() => {});
  }, []);

  return (
    <div className="App" data-testid="big-bear-app">
      <Toaster position="top-right" richColors />
      <Nav />
      <main>
        <Hero />
        <Work />
        <Services />
        <Results />
        <Partners />
        <Testimonials />
        <Footer />
      </main>
    </div>
  );
}

export default App;
